

















































import { Component } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import { SubTransactionTypesModule } from '@/store/Products/SubTransactionTypesModule';
import CreateSubTransactionTypeRequest from '@/models/Products/SubTransactionTypes/CreateSubTransactionTypeRequest';
import PageNames from '@/router/PageNames';

@Component({ name: 'CreateSubTransactionType' })
export default class extends SaascadaVueDialog {

    request: CreateSubTransactionTypeRequest = new CreateSubTransactionTypeRequest();

    async save() {
        if (!(this.$refs.form as any).validate()) {
            return;
        }
        else {
            this.dialog = false;

            await SubTransactionTypesModule.createSubTransactionType(this.request);

            if (SubTransactionTypesModule.newTransactionTypeID != null) {
                this.$router.push({ name: PageNames.SubTransactionType, params: { id: SubTransactionTypesModule.newTransactionTypeID } });
            }
        }
    }

}
